import { tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { DocStatuses } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FlowSheet } from '@app/advisor-content-shared';
import { DBDef_EHRInstallation } from '../ehr-installation/index.js';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    ehrInstallationId: tsValidateUniqueId,
    dbNoteId: tsValidateUniqueId,
    installationNoteCode: tsValidateString(),
    docStatus: tsValidateValue([...DocStatuses]),
};
const Validator_GeneratedProps = {};
export const DBDef_InstallationFlowsheetConfiguration = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'installation-flowsheet-configuration',
    entityName: 'EHR Flowsheet Configuration',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'installation-flowsheet-configuration'
    },
    backend: {
        name: 'installation-flowsheet-configuration'
    },
    dependencies: {
        ehrInstallationId: {
            dbKey: DBDef_EHRInstallation.dbKey,
            fieldType: 'string',
        },
        dbNoteId: {
            dbKey: DBDef_FlowSheet.dbKey,
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map